import axios from 'axios';
import { store } from '../store';

export const getFileUploadURL = (fileName, carrier = false) => {
  const { token } = store.getState().auth;
  let endpointURL = `${process.env.REACT_APP_MMB_API_URL}/api/utils/formulary/upload/?site=dev.mymedicarebot.com&filename=${fileName}`;
  if (carrier) {
    endpointURL = `${process.env.REACT_APP_MMB_API_URL}/api/utils/formulary/upload/?site=dev.mymedicarebot.com&filename=${fileName}&carrier=true`;
  }
  return new Promise((resolve, reject) => {
    axios({
      url: endpointURL,
      headers: { Authorization: `Token ${token}` },
    }).then(({ data }) => {
      resolve(data);
    }).catch((err) => {
      // console.log(err);
      reject(err);
    });
  });
};

export const uploadFile = (file, dataObject) => (
  new Promise((resolve, reject) => {
    const instance = axios.create();
    instance.defaults.params = { site: null };

    const uploadURL = dataObject.url;
    const uploadFields = dataObject.fields;

    const formData = new FormData();
    formData.append('key', uploadFields.key);
    formData.append('AWSAccessKeyId', uploadFields.AWSAccessKeyId);
    formData.append('policy', uploadFields.policy);
    formData.append('signature', uploadFields.signature);
    formData.append('x-amz-security-token', uploadFields['x-amz-security-token']);
    formData.append('file', file);

    instance({
      method: 'post',
      url: uploadURL,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
    }).then(({ data }) => {
      resolve(data);
    }).catch((err) => {
      // console.log(err);
      reject(err);
    });
  })
);
